module.exports = __webpack_public_path__ + "static/img/3469_phase_function_Paper_PointsHejduk_Prediction.3a78036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3469_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tkJ7
// module chunks = 0